import { useEasterEggs } from './hooks/useEasterEggs';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { HiddenTerminal } from './components/HiddenTerminal';
import { MarginFlair } from './components/MarginFlair';

function App() {
  const { terminalOpen, closeTerminal } = useEasterEggs();

  return (
    <div style={{ 
      backgroundColor: 'var(--paper)', 
      color: 'var(--charcoal)',
      minHeight: '100vh',
      fontFamily: "'Crimson Text', Georgia, serif",
      position: 'relative',
    }}>
      <main>
        <Hero />
        <About />
      </main>
      <MarginFlair />
      {terminalOpen && <HiddenTerminal onClose={closeTerminal} />}
    </div>
  );
}

export default App;
